export const times = (_times)=>{
    const times =[]
    for(_times !== 0; _times--;){
        times.push(_times)
    }

    return times.reverse()
}


export const getPosition = (elem) =>{
    let location = 0;
    if (elem.offsetParent) {
        do {
            location += elem.offsetTop;

            if(elem.parentNode !== document.body){
                elem = elem.parentNode;
            }else{
                elem = null
            }
        } while (elem);
    }
    return location >= 0 ? location : 0;
}


// WEBPACK FOOTER //
// ./src/lib/utils.js